import React from "react";
import styled from "styled-components";
import IconSAT from '../../assets/images/icon-sat.svg'

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: #FFFFFF;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999;

    .box {
        width: 100%;
        height: 100%;
        background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    }

    .icon {
        width: 100px;
    }

    .description {
        color: #25368D;
        font-size: 20px;
        font-weight: 400;
        line-height: 29.9px;
        text-align: center;
        margin-top: 16px;
    }
`;

function EvaluationFormNoData({
    type
}) {
    return (
        <Container>
            <div className="content-center box">
                <div>
                    <div className="horizontal-center">
                        <img alt="img" className="icon" src={IconSAT} />
                    </div>
                    <div className="description">
                        {type === "out_area" ?
                            <>
                                แบบประเมินอยู่เกินระยะที่กำหนด <br /> กรุณาลองใหม่อีกครั้ง
                            </> :
                            type === "inactive" ?
                                <>
                                    แบบประเมินยังไม่เปิดใช้งาน <br /> กรุณาติดต่อเจ้าหน้าที่
                                </> :
                                type === "expired" ?
                                    <>
                                        แบบประเมินหมดอายุ <br /> กรุณาติดต่อเจ้าหน้าที่
                                    </> :
                                    <>
                                        ไม่พบแบบประเมินที่ต้องการ <br /> กรุณาติดต่อเจ้าหน้าที่
                                    </>
                        }
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default EvaluationFormNoData;